import React, { Component } from 'react';
import { Form, Input, Checkbox } from 'antd';

import { AccountStatusType } from '../account-status-type/account-status-type'
import { Department } from '../department/department'

export class AccountStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const { typeOption, editable } = this.props;
        return <>
            <Form.Item
                className="checkbox-style"
                name='user_status'
                label='* Trạng thái tài khoản::'
                rules={[
                ]}>
                <AccountStatusType
                    typeOption={typeOption}
                    editable={editable}/>
            </Form.Item>
            <Form.Item
                className="notRequired checkbox-style"
                name='department'
                label='* Bộ phận::'
                rules={[
                ]}>
                <Department typeOption={typeOption} editable={editable} />
            </Form.Item>
        </>
    }
}